// src/data/products.js
const products = [
  {
    id: 1,
    productType: 'variable',
    name: 'Modular Shelf',
    description: 'Versatile modular shelving system for customizable retail displays.',
    price: 100,
    salePrice: 80,
    image: '/modular-shelf.jpg',
    categories: ['Shop Shelving'],
    subcategories: ['Modular Shelving'],
    industries: ['Tech shops', 'DIY', 'Grocery store'],
    modelUrl: 'https://modelviewer.dev/shared-assets/models/Chair.glb',
    colors: ['Matte Black', 'Graphite', 'Pearl White'],
    sizes: ['900mm', '1200mm', '1500mm'],
    material: 'Powder-coated steel with MDF shelves',
    finish: 'Anti-scratch matte',
    warranty: '24 months',
    leadTime: '3-5 business days',
    specs: {
      loadCapacity: '120kg per bay',
      assembly: 'Flat-pack, tool-assisted',
      compliance: 'Commercial grade',
    },
  },
  {
    id: 2,
    productType: 'variable',
    name: 'Double Door Chiller',
    description: 'Energy-efficient refrigeration unit with double glass doors.',
    price: 500,
    image: '/chiller.jpg',
    categories: ['Refrigeration'],
    subcategories: ['Display Chillers'],
    industries: ['Greengrocer', 'Butcher', 'Restaurants'],
    modelUrl: 'https://modelviewer.dev/shared-assets/models/RobotExpressive.glb',
    colors: ['Black', 'Silver'],
    sizes: ['900L', '1200L'],
    material: 'Galvanized steel body and tempered glass doors',
    finish: 'Powder-coated exterior',
    warranty: '18 months',
    leadTime: '5-7 business days',
    specs: {
      temperatureRange: '2°C to 8°C',
      energyClass: 'A+',
      shelves: '8 adjustable levels',
    },
  },
  {
    id: 3,
    productType: 'variable',
    name: 'Vape Display Stand',
    description: 'Secure display stand for high-value products with custom lighting.',
    price: 200,
    salePrice: 150,
    image: '/glass-counter.jpg',
    categories: ['Displays'],
    industries: ['Vape shop', 'Tech shops'],
    colors: ['Charcoal', 'White'],
    sizes: ['Small', 'Medium'],
    material: 'Steel frame with lockable glass case',
    finish: 'Brushed metal trims',
    warranty: '12 months',
    leadTime: '3-5 business days',
    specs: {
      lighting: 'Integrated LED strips',
      security: 'Lock-and-key doors',
      footprint: 'Compact counter-top',
    },
  },
  {
    id: 4,
    productType: 'simple',
    name: 'Black Vinyl Flooring',
    description: 'Heavy-duty carbon maxi fast track vinyl flooring in black.',
    price: 300,
    image: '/flooring.jpg',
    categories: ['Flooring'],
    industries: ['Pound shop', 'Pet shop', 'Organic shops'],
    colors: ['Jet Black', 'Slate'],
    sizes: ['2m Roll', '4m Roll'],
    material: 'Commercial vinyl composite',
    finish: 'Slip-resistant texture',
    warranty: '10 years',
    leadTime: '2-4 business days',
    specs: {
      thickness: '3.2mm',
      wearLayer: '0.7mm heavy duty',
      maintenance: 'Low maintenance',
    },
  },
  {
    id: 5,
    productType: 'variable',
    name: 'Bakery & Bread Rack',
    description: 'Beautiful slatted wood display rack perfect for fresh bakery items.',
    price: 150,
    image: '/wall-bays.jpg',
    categories: ['Displays', 'Shop Shelving'],
    subcategories: ['Bakery Racks'],
    industries: ['Bakery', 'Grocery store'],
    colors: ['Oak', 'Walnut'],
    sizes: ['3 Tier', '5 Tier'],
    material: 'Hardwood slats with steel supports',
    finish: 'Food-safe sealant',
    warranty: '12 months',
    leadTime: '4-6 business days',
    specs: {
      airflow: 'Open slat ventilation',
      mobility: 'Optional castor wheels',
      cleaning: 'Wipe-clean finish',
    },
  },
  {
    id: 6,
    productType: 'variable',
    name: 'Glass Display Counter',
    description: 'Premium glass counter for jewelry, tech accessories, and more.',
    price: 450,
    image: '/glass-counter.jpg',
    categories: ['Displays', 'Checkout'],
    subcategories: ['Glass Counters'],
    industries: ['Tech shops', 'Pharmacy store'],
    colors: ['Black', 'White', 'Silver'],
    sizes: ['1200mm', '1500mm'],
    material: 'Aluminium frame with tempered glass',
    finish: 'Gloss powder coat',
    warranty: '24 months',
    leadTime: '5-8 business days',
    specs: {
      lockSystem: 'Dual lock',
      shelves: '2 internal glass shelves',
      storage: 'Rear cabinet',
    },
  },
  {
    id: 7,
    productType: 'simple',
    name: 'Clothing Rack',
    description: 'Mobile heavy-duty clothing rack with adjustable height.',
    price: 85,
    image: '/modular-shelf.jpg',
    categories: ['Shop Shelving'],
    industries: ['Retail', 'Clothing store'],
    colors: ['Chrome', 'Black'],
    sizes: ['Single Rail', 'Double Rail'],
    material: 'Tubular steel',
    finish: 'Anti-rust chrome plating',
    warranty: '12 months',
    leadTime: '2-3 business days',
    specs: {
      heightRange: '1.2m to 1.8m',
      mobility: 'Lockable wheels',
      loadCapacity: '90kg',
    },
  },
  {
    id: 8,
    productType: 'variable',
    name: 'Gondola Shelving Unit',
    description: 'Double-sided freestanding aisle shelving for supermarkets.',
    price: 180,
    image: '/wall-bays.jpg',
    categories: ['Shop Shelving'],
    subcategories: ['Gondola Shelving'],
    industries: ['Grocery store', 'Pharmacy store', 'Pound shop'],
    modelUrl: 'https://modelviewer.dev/shared-assets/models/Horse.glb',
    colors: ['Arctic White', 'Graphite'],
    sizes: ['900mm', '1200mm', '1500mm'],
    material: 'Commercial steel frame',
    finish: 'Electrostatic powder coat',
    warranty: '24 months',
    leadTime: '3-5 business days',
    specs: {
      baseDepth: '470mm',
      shelfLevels: '5 adjustable',
      endCaps: 'Compatible',
    },
  },
  {
    id: 9,
    productType: 'simple',
    name: 'Store Checkout Counter',
    description: 'Durable and spacious checkout counter with built-in storage.',
    price: 550,
    image: '/store-counter.jpg',
    categories: ['Checkout', 'Accessories'],
    subcategories: ['Checkout Counters'],
    industries: ['Grocery store', 'Tech shops', 'Retail'],
    colors: ['Black', 'White Oak'],
    sizes: ['1500mm', '1800mm'],
    material: 'Steel carcass with laminated top',
    finish: 'Scratch-resistant laminate',
    warranty: '24 months',
    leadTime: '5-8 business days',
    specs: {
      tillCutout: 'Included',
      storage: '3 lockable drawers',
      cableManagement: 'Rear grommets',
    },
  },
  {
    id: 10,
    productType: 'simple',
    name: 'Wall Bays',
    description: 'Integrated wall shelving units for maximum perimeter product display.',
    price: 120,
    image: '/wall-bays.jpg',
    categories: ['Shop Shelving', 'Slatwall Panels'],
    subcategories: ['Wall Bays'],
    industries: ['Pharmacy store', 'DIY', 'Organic shops'],
    colors: ['Pearl White', 'Anthracite'],
    sizes: ['900mm', '1200mm'],
    material: 'Steel uprights with adjustable shelves',
    finish: 'Powder-coated satin',
    warranty: '24 months',
    leadTime: '3-5 business days',
    specs: {
      shelfDepth: '300mm / 370mm',
      compatibility: 'Hooks and rail accessories',
      maxHeight: '2400mm',
    },
  },
  {
    id: 11,
    productType: 'custom',
    name: 'Off-Licence Back Bar Wall Unit',
    description: 'Tall reinforced wall bay system designed for spirits and premium bottle display.',
    price: 690,
    salePrice: 620,
    image: '/wall-bays.jpg',
    categories: ['Off-Licence Fittings', 'Shop Shelving'],
    subcategories: ['Wall Bays'],
    industries: ['Off licence', 'Grocery store', 'Tech shops'],
    modelUrl: 'https://modelviewer.dev/shared-assets/models/Astronaut.glb',
    colors: ['Gunmetal', 'Matte Black', 'Walnut'],
    sizes: ['1800mm', '2400mm'],
    material: 'Reinforced steel with timber feature shelves',
    finish: 'Premium textured powder coat',
    warranty: '36 months',
    leadTime: '7-10 business days',
    specs: {
      bottleRails: 'Integrated front rails',
      lighting: 'Optional warm LED',
      loadCapacity: '150kg per bay',
    },
  },
  {
    id: 12,
    productType: 'custom',
    name: 'Security Till Counter with Gate',
    description: 'Compact checkout station with lockable cabinet and side swing-gate for controlled exits.',
    price: 840,
    image: '/store-counter.jpg',
    categories: ['Off-Licence Fittings', 'Checkout'],
    subcategories: ['Till Counters'],
    industries: ['Off licence', 'Pound shop', 'Retail'],
    modelUrl: 'https://modelviewer.dev/shared-assets/models/NeilArmstrong.glb',
    colors: ['Black', 'Charcoal', 'Oak Front'],
    sizes: ['1500mm', '2000mm'],
    material: 'Steel and laminate composite',
    finish: 'Security-grade finish with anti-scuff edges',
    warranty: '36 months',
    leadTime: '7-10 business days',
    specs: {
      gateType: 'Self-closing swing gate',
      cabinet: 'Lockable under-counter',
      scannerMount: 'Universal bracket',
    },
  },
  {
    id: 13,
    productType: 'custom',
    name: 'Cigarette Gantry Unit',
    description: 'High-capacity tobacco gantry with adjustable shelves and shutter-ready frame.',
    price: 510,
    image: '/glass-counter.jpg',
    categories: ['Off-Licence Fittings', 'Displays'],
    industries: ['Off licence', 'Vape shop'],
    modelUrl: 'https://modelviewer.dev/shared-assets/models/CartoonLowPolyKnight.glb',
    colors: ['Black', 'White'],
    sizes: ['1200mm', '1800mm'],
    material: 'Steel gantry with aluminium channels',
    finish: 'Retail-grade powder coat',
    warranty: '24 months',
    leadTime: '5-7 business days',
    specs: {
      shelfPitch: 'Multi-position shelf slots',
      shutterReady: 'Yes',
      lighting: 'Optional strip LEDs',
    },
  },
  {
    id: 14,
    productType: 'variable',
    name: 'Wine & Spirits Island Gondola',
    description: 'Center-floor gondola system with bottle rails, promo end caps, and anti-slip decks.',
    price: 760,
    salePrice: 710,
    image: '/modular-shelf.jpg',
    categories: ['Off-Licence Fittings', 'Shop Shelving'],
    industries: ['Off licence', 'Organic shops', 'Bakery'],
    modelUrl: 'https://modelviewer.dev/shared-assets/models/shishkebab.glb',
    colors: ['Black', 'Walnut', 'Stone Grey'],
    sizes: ['1200mm', '1800mm', '2400mm'],
    material: 'Heavy-duty steel chassis with timber shelves',
    finish: 'Textured anti-slip deck coating',
    warranty: '36 months',
    leadTime: '7-10 business days',
    specs: {
      endCaps: 'Promo-ready',
      bottleRails: 'Front and side',
      loadCapacity: '130kg per side',
    },
  },
];

export default products;
